/** @jsxImportSource theme-ui */

import React from 'react';
import { ResponsiveStyleValue } from 'theme-ui';
import { TextVariantProp } from '../../theme/custom/text';
import {
    AllCaroteneColors,
    FontFamilyProps,
    FontSizeProps,
    FontWeightProps,
    StyleOverrideProps,
    TextAlign,
} from '../utils/types';

interface TextOverrideProps {
    color?: AllCaroteneColors;
}
export interface TextProps
    extends FontFamilyProps,
        FontWeightProps,
        FontSizeProps,
        Omit<React.HTMLAttributes<HTMLSpanElement>, 'color' | 'css' | 'fontSize'>,
        TextOverrideProps,
        StyleOverrideProps {
    variant?: TextVariantProp;
    fontStyle?: ResponsiveStyleValue<'normal' | 'italic' | 'oblique' | 'initial' | 'inherit'>;
    as?: 'span' | 'p' | 'div';
    align?: TextAlign;
}

export default function Text({
    variant,
    weight,
    size,
    fontStyle,
    as: Component,
    color,
    font,
    align,
    children,
    sx,
    ...otherProps
}: TextProps): JSX.Element {
    const additionalOverrides = {} as TextOverrideProps;
    if (color) {
        additionalOverrides.color = color;
    }
    return (
        <Component
            {...otherProps}
            sx={{
                variant: `text.${variant}`,
                fontWeight: weight,
                fontSize: size,
                fontFamily: font,
                textAlign: align,
                fontStyle,
                ...additionalOverrides,
                ...sx,
            }}
        >
            {children}
        </Component>
    );
}
Text.defaultProps = {
    variant: 'default',
    size: 'medium',
    as: 'span',
};
